import { LoadingBar as LoadingBarBase } from 'components/feedback/LoadingBar';
import { defaultBrand } from 'containers/PublicJobBoard/boardTheme/colors';

const boardTheme = {
  colors: { primary: defaultBrand.primary },
};

export const LoadingBar = () => <LoadingBarBase theme={boardTheme} />;
